import type { ElementKind, ResolverName } from '../types';

export const getResolverName = (elementKind: ElementKind) =>
    `get${elementKind[0].toUpperCase() + elementKind.slice(1)}` as ResolverName;
